import {FormModalProps} from "../../../../../utils/useFormModal";
import {Form, Input, Modal, Select as AntSelect} from "antd";
import Select from "../../../../../components/Select";
import * as dealerApi from "../../../../../apis/dealer";

const sysNameOptions = [
    {value: '美年', label: '美年'},
    {value: '新美年', label: '新美年'},
    {value: '云医购', label: '云医购'}
]

function ModifyModal(props: FormModalProps) {
    const {form, ...otherProps} = props;

    return <Modal width={600} title={'外部系统客户映射'} {...otherProps}>
        <Form form={form} layout={"vertical"}>
            <Form.Item name={'id'} noStyle/>
            <Form.Item name={'sysName'} label={'外部系统'} initialValue={'美年'}>
                <AntSelect options={sysNameOptions}>

                </AntSelect>
            </Form.Item>
            <Form.Item name={'customerNo'} label={'客户编号'}>
                <Select url={dealerApi.getDealers} valueField={'no'} textField={'name'} onChange={(v, o:any)=>form.setFieldValue('customerName',o.name)}
                    getData={data=>data.data?.map((item:any)=>({...item, name: `${item.no}（${item.name}）`}))}/>
            </Form.Item>
            <Form.Item name={'externalCustomerNo'} label={'外部客户编号'} >
                <Input/>
            </Form.Item>
            <Form.Item name={'externalCustomerName'} label={'外部客户名称'} >
                <Input/>
            </Form.Item>
        </Form>
    </Modal>
}

export default ModifyModal;
